import { Link } from "react-router-dom";
import { Phone, MessageCircle, CalendarCheck } from "lucide-react";
import { Reveal } from "./Reveal";
import { PHONE_DISPLAY, PHONE_TEL, WA_LINK } from "../../lib/site";
import { useLang } from "../../lib/i18n";

export const ContactBand = () => {
    const { t } = useLang();
    return (
    <section id="contact" data-testid="contact-section" className="grain relative overflow-hidden border-t border-white/8 bg-night-900/60 py-24 sm:py-32">
        <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-0 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-amber-400/8 blur-[120px]" />
        <div className="container-x relative text-center">
            <Reveal>
                <p className="eyebrow">{t.contact.eyebrow}</p>
            </Reveal>
            <Reveal delay={0.1}>
                <h2 className="mt-5 font-display font-wide text-4xl font-black uppercase leading-none tracking-tight text-white sm:text-6xl lg:text-7xl">
                    {t.contact.titleA}<span className="text-amber-400">{t.contact.titleB}</span>
                </h2>
            </Reveal>
            <Reveal delay={0.2}>
                <a
                    href={PHONE_TEL}
                    data-testid="contact-phone-big"
                    className="mt-9 inline-block font-mono text-3xl font-bold tracking-wider text-white transition-colors duration-300 hover:text-amber-300 sm:text-5xl"
                >
                    {PHONE_DISPLAY}
                </a>
            </Reveal>
            <Reveal delay={0.3}>
                <div className="mt-10 flex flex-wrap items-center justify-center gap-3.5">
                    <a href={PHONE_TEL} data-testid="contact-cta-call" className="btn-amber px-7 py-4 text-base">
                        <Phone size={18} /> {t.contact.call}
                    </a>
                    <a href={WA_LINK} target="_blank" rel="noopener noreferrer" data-testid="contact-cta-whatsapp" className="btn-outline px-7 py-4 text-base">
                        <MessageCircle size={18} /> {t.contact.whatsapp}
                    </a>
                    <Link to="/boeken" data-testid="contact-cta-book" className="btn-ghost px-5 py-4 text-base underline decoration-amber-400/50 underline-offset-8">
                        <CalendarCheck size={18} /> {t.contact.book}
                    </Link>
                </div>
            </Reveal>
            <Reveal delay={0.4}>
                <p className="mt-8 font-mono text-xs uppercase tracking-[0.25em] text-slate-500">
                    {t.contact.note}
                </p>
            </Reveal>
        </div>
    </section>
    );
};
